import { render, staticRenderFns } from "./ProductDate.vue?vue&type=template&id=12edda20&scoped=true&"
import script from "./ProductDate.vue?vue&type=script&lang=js&"
export * from "./ProductDate.vue?vue&type=script&lang=js&"
import style0 from "./ProductDate.vue?vue&type=style&index=0&id=12edda20&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12edda20",
  null
  
)

export default component.exports